import { default as VueSizeDetector } from 'vue-size-detector/src/index'

export default function(Vue, options) {
	VueSizeDetector(Vue)
}